export default __webpack_public_path__ + "static/media/video.4fa1f302.mp4";